export default "__VITE_ASSET__Dv1xsWsp__"